import { companiesRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { CompanyKeys } from './keys';

export const useGetCompanyProfilePicture = (
  companyId: number,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: CompanyKeys.PROFILE_PICTURE(companyId),
    queryFn: () => companiesRepo.getProfilePictureById(companyId),
    enabled,
  });
};
